import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { getPage } from '../utilities/paging';

const PaginationItem = ({ currentPage, pageIndex, pageNumber, pageSize }) => {
	const { widgetName, windowId } = useSelector((state) => state.requestData);
	const labels = useLabels();
	const itemStart = pageIndex * pageSize;
	const href = `${window.location.pathname}?start=${itemStart}`;
	const isCurrent = pageIndex === currentPage;
	const active = isCurrent ? 'active' : null;

	return (
		<li className={active}>
			<a
				href={href}
				aria-current={isCurrent ? 'page' : null}
				onClick={(e) =>
					getPage(
						e,
						itemStart,
						'specific',
						widgetName,
						windowId,
						pageNumber
					)
				}
				aria-label={
					isCurrent
						? null
						: labels
								.get('GO_TO_PAGE_X')
								.replace('{pageNumber}', pageNumber)
				}
			>
				{pageNumber}
			</a>
		</li>
	);
};

PaginationItem.propTypes = {
	currentPage: PropTypes.number.isRequired,
	pageIndex: PropTypes.number.isRequired,
	pageNumber: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired
};

export default PaginationItem;
